<template>
    <el-dialog width="750px" :title="userDepartmentTitle" :before-close="handleClickCancel" :close-on-press-escape="false" class="custom-form-dialog"
               :close-on-click-modal="false" :visible.sync="userDepartmentVisible" :append-to-body="true">
        <div class="user_department_wrap" v-if="userDepartmentVisible">
            <div class="left_selectable_wrap">
                <div class="title_wrap">可选</div>
                <div style="padding: 0 15px 0" >
                    <el-input @keyup.enter.native="getDepartmentAndUserList"
                              placeholder="请输入部门名称或员工姓名"
                              size="small"
                              v-model="keyWord">
                        <i @click="getDepartmentAndUserList" class="el-icon-search" slot="suffix"></i>
                    </el-input>
                </div>
                <div class="scroll_wrap">
                    <el-tree :data="selectable_list"
                             :default-expand-all="true"
                             :default-expanded-keys="default_expanded"
                             :expand-on-click-node='false'
                             :props="defaultProps"
                             @check="handleCheckNodeItem"
                             check-on-click-node
                             :check-strictly="localCheckStrictly"
                             node-key="relate_type_id"
                             ref="dep_and_user_tree"
                             show-checkbox>
                    </el-tree>
                </div>
            </div>
            <div class="right_selected_wrap">
                <div class="title_wrap">
                    <div>已选</div>
                    <div style="font-size: 12px" v-if="selected_list.length>0">
                    <span v-if="selected_list.filter(item=>item.relate_type=='App\\Models\\Department').length"  v-text="selected_list.filter(item=>item.relate_type=='App\\Models\\Department').length + '个部门'">
                    </span>
                        &nbsp;
                        <span v-if="selected_list.filter(item=>item.relate_type=='App\\Models\\User').length"  v-text="selected_list.filter(item=>item.relate_type=='App\\Models\\User').length + '人'">
                    </span>
                    </div>
                </div>
                <ul class="selected_list">
                    <li :key="index" class="selected_item" v-for="(item,index) in selected_list">
                        <span v-text="item.relate_name"></span>
                        <el-button @click="handleClickDelSelected(item,index)"
                                   icon="el-icon-delete"
                                   type="text">
                        </el-button>
                    </li>
                </ul>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {GetDepartmentUserList,GetDepartmentList } from "@/api/index.js"
export default {
    name: "userSelection",
    props: {
        userDepartmentVisible: {
            type: Boolean,
            default: false,
        },
        userDepartmentTitle:{
            type: String,
            default: '选择',
        },
        userDepartmentSelected:{
            type: Array,
            default: () => []
        },
        // 禁用的数据 不可选的
        userDepartmentDisabled: {
            type: Array,
            default: () => []
        },
        checkStrictly: {
            type: Boolean,
            default: false, //tree 父子是否互相关联
        },
        type:{
            type: String,
            default: 'userDepartment', // user 人员(在部门下之选中人员) department //部门   userDepartment//部门人员
        },

    },
    data() {
        return {
            localCheckStrictly: this.checkStrictly,
            BtnDisabled:false,
            selectable_list: [],
            default_expanded: [],
            defaultProps: {
                children: 'children',
                label: 'relate_name',
                disabled:(data, node)=> {
                    return this.userDepartmentDisabled.includes(data.relate_type_id)
                }
            },
            selected_list: [],
            keyWord: '',
        };
    },
    created() {
        if(this.type == 'user'){
            this.localCheckStrictly = false
        }

        if(this.userDepartmentSelected){
            this.selected_list = JSON.parse(JSON.stringify(this.userDepartmentSelected))
        }
        this.getDepartmentAndUserList()
    },
    methods: {
        getDepartmentAndUserList() {
            if(this.type == 'department'){
                GetDepartmentList({name: this.keyWord}).then(res=> {
                    if(res.code === 200) {
                        this.selectable_list = res.data || []
                        this.recursionAddRelateType(this.selectable_list)
                        this.$nextTick(()=>{
                            this.selected_list.forEach((item)=>{
                                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true)
                            })
                        })
                    }
                })
            }else if(this.type == 'userDepartment' || this.type == 'user'){
                GetDepartmentUserList({name: this.keyWord}).then(res=> {
                    if(res.code === 200) {
                        this.selectable_list = res.data || []
                        this.recursionAddRelateType(this.selectable_list)
                        this.$nextTick(()=>{
                            this.selected_list.forEach((item)=>{
                                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true)
                            })
                        })
                    }
                })
            }
        },


        recursionAddRelateType(arr) {
            arr.forEach(item => {
                item.relate_type_id = item.relate_id + '_' +item.relate_type
                if (item.children && item.children.length > 0) {
                    this.recursionAddRelateType(item.children)
                }
            })
        },


        handleCheckNodeItem(data, {checkedKeys, checkedNodes}) {
            const dataIndex = checkedKeys.findIndex(check => check === data.relate_type_id)
            if (dataIndex > -1) {
                this.selected_list.push({
                    relate_type_id:data.relate_type_id,
                    relate_id: data.relate_id,
                    relate_name: data.relate_name,
                    relate_type: data.relate_type,
                })
            } else {
                this.selected_list.splice(this.selected_list.findIndex(item => item.relate_type_id === data.relate_type_id), 1)
            }

        },


        handleClickDelSelected(item, index) {
            this.selected_list.splice(index, 1)
            this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false)
        },
        handleClickCancel(){
            this.selected_list = []
            this.$emit('update:userDepartmentVisible', false)
        },
        handleClickConfirm(){
            if(this.selected_list.length > 1) return this.$message.error("只能选择一个人员")
            if((this.selected_list.length == 1 && this.selected_list[0].relate_type !== 'App\\Models\\User') || !this.selected_list.length) return this.$message.error("请选择一个人员")
            this.$emit('success',JSON.parse(JSON.stringify(this.selected_list)))
            this.selected_list = []
            this.$emit('update:userDepartmentVisible', false)
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input__suffix{
    top: 8px;
}
.user_department_wrap {
    width: 100%;
    height:50vh;
    display: flex;
    justify-content: space-between;
}

.left_selectable_wrap {
    flex: 1;
    height: 100%;
    margin-right: 15px;
    border-radius: 6px;
    border: 1px solid #f3f3f3;
}

.right_selected_wrap {
    flex: 1;
    border-radius: 6px;
    border: 1px solid #f3f3f3;
}

.title_wrap {
    height: 40px;
    font-size: 16px;
    color: #333333;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
}

.left_selectable_wrap .scroll_wrap {
    padding: 0 15px;
    margin-top: 15px;
    width: 100%;
    height: calc(100% - 105px);
    overflow-y: scroll;
}

.right_selected_wrap .selected_list {
    width: 100%;
    height: calc(100% - 55px);
    overflow-y: scroll;
}

.right_selected_wrap .selected_list .selected_item {
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
}

.right_selected_wrap .selected_list .selected_item:hover {
    background-color: rgba(25, 144, 255, 0.16);
    color: #1990FF;
}
</style>

